import React from 'react';

import { arrayOf, shape, string, node, oneOf, oneOfType } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

const TYPES = ['header', 'body', 'actions'];

export default class ModalSection extends BaseComponent {
  render() {
    const { children, className, id, style, type } = this.props;

    const classNames = ClassNames(['ModalSection', className, type]);

    return (
      <div style={style} id={id} className={classNames}>
        {children}
      </div>
    );
  }
}

ModalSection.propTypes = {
  style: shape({}),
  id: string,
  className: string,
  children: oneOfType([arrayOf(node), node]).isRequired,
  type: oneOf(TYPES)
};

ModalSection.defaultProps = {
  style: {},
  id: undefined,
  className: undefined
};
